<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.65 36.8261L14.5239 29.7782L16.8218 27.4521L21.65 32.1804L30.8783 22.9521L33.1761 25.3282L21.65 36.8261ZM9.25436 44.7066C8.17079 44.7066 7.23976 44.3173 6.46126 43.5388C5.68272 42.7603 5.29346 41.8292 5.29346 40.7457V10.2543C5.29346 9.16301 5.68272 8.22531 6.46126 7.44125C7.23976 6.65721 8.17079 6.2652 9.25436 6.2652H12.25V3.2652H15.9805V6.2652H32.0196V3.2652H35.75V6.2652H38.7457C39.837 6.2652 40.7747 6.65721 41.5588 7.44125C42.3428 8.22531 42.7348 9.16301 42.7348 10.2543V40.7457C42.7348 41.8292 42.3428 42.7603 41.5588 43.5388C40.7747 44.3173 39.837 44.7065 38.7457 44.7065H9.25436V44.7066ZM9.25436 40.7457H38.7457V19.5H9.25436V40.7457ZM9.25436 16.5H38.7457V10.2543H9.25436V16.5Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
